import { render } from "./TextingAssistant.vue?vue&type=template&id=17ca8d40"
import script from "./TextingAssistant.vue?vue&type=script&lang=js"
export * from "./TextingAssistant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__